import type { LoyaltyFeatureConfig } from './type';

export const loyalty: Partial<LoyaltyFeatureConfig> = {
    icon: 'coins',
    targetClientId: 'gstore',
};
